import { Flex } from '@mantine/core';
import { TimeInput } from '@mantine/dates';
import { Dayjs } from 'dayjs';
import { useRef } from 'react';
import { dayjsPlugins } from '../../providers/dayjs-plugins';
import { CustomDatePicker } from '../custom-date-picker';

interface CustomDateTimePickerProps {
  date: Date | null;
  onChange: (dateTime: Date) => void;
  label: string;
  disabled?: boolean;
  canChangeDate?: boolean;
}

export function CustomDateTimePicker({
  date,
  onChange,
  label,
  disabled = false,
  canChangeDate = true,
}: CustomDateTimePickerProps) {
  const dateOverride = useRef(date);

  function setDateTime(datex: Dayjs, time: Dayjs) {
    onChange(
      dayjsPlugins(
        `${datex.format('YYYY-MM-DD')}T${time.format('HH:mm:ss')}`,
      ).toDate(),
    );
  }

  return (
    <Flex>
      <CustomDatePicker
        disabled={disabled || !canChangeDate}
        label={label}
        clearable={false}
        placeholder="selecione uma data"
        styles={{ input: { border: 0 } }}
        value={dateOverride.current}
        onChange={(dates: Date) => {
          dateOverride.current = dates;
          setDateTime(
            dayjsPlugins(dateOverride.current),
            dayjsPlugins(dateOverride.current),
          );
        }}
      />
      <TimeInput
        disabled={disabled}
        label="Hora (24h)"
        clearable={false}
        styles={{ input: { border: 0 } }}
        value={dateOverride.current}
        onChange={(values) =>
          setDateTime(dayjsPlugins(dateOverride.current), dayjsPlugins(values))
        }
      />
    </Flex>
  );
}
